import { ICiStaticResourcesType } from '@/model/globalModel'
import { IPage } from '@/types/AppTypes'
import { getBaseCiRequestUrl, getToken } from './constants'
import { httpRequest } from './HttpRequest'

//搜索条件
export interface IOrderListSearchVo {
    searchItem: {
        orderStatus: string[]
        [key: string]: any
    }
    startTime?: string | null
    endTime?: string | null
    pageNum: number
    pageSize: number
    orders: [{ column: 'updateTime'; rule: 'DESC' }]
}

export interface ICiDict {
    dictCode: string
    dictNumber: string
    dictType: string
    disableFlag: number
    id: string
    parentCode: string | null
    remark?: string
    title: string
    children?: ICiDict[]
}

export interface IOrderMaterialSearchVo {
    pageSize: number
    searchItem: { orderId: string; serviceNature: string[] }
}

export interface IOrderSanbaoSearchVo {
    searchItem: { orderId: string; search: { [key: string]: any } }
    pageNum: number
    pageSize: number
    orders: { column: string; rule: string }[]
}


export interface ICiSearchVo  {
    searchItem: {  [key: string]: any  }
    pageNum: number
    pageSize: number
    orders: { column: string; rule: string }[]
}
class CI {
    //云创订单列表
    async ciOrderList(searchVo: IOrderListSearchVo) {
        const apiUrl = '/ci/order/platform_list'
        return await httpRequest.post<any>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    //云创订单详单
    async ciOrderDetail(id: string) {
        const apiUrl = `/ci/order/platform_one/${id}`
        return await httpRequest.post<any>(apiUrl, {},{ baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    //云创订单配件
    async ciOrderMaterial(searchVo: IOrderMaterialSearchVo) {
        const apiUrl = `/ci/order/maintan-material/list`
        return await httpRequest.post<any>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    //云创订单项目
    async ciOrderItem(searchVo: IOrderMaterialSearchVo) {
        const apiUrl = `/ci/order/item/list`
        return await httpRequest.post<any>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    //云创订单三包
    async ciOrderSanbao(searchVo: IOrderSanbaoSearchVo) {
        const apiUrl = `/ci/order_three_guarantees/list`
        return await httpRequest.post<any>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
     //云创订单三包详情
     async ciOrderSanbaoDetail(id: string) {
        const apiUrl = `/ci/order_three_guarantees/detail/${id}`
        return await httpRequest.get<any>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    //云创订单图片
    async ciOrderImg(searchVo: ICiSearchVo) {
        const apiUrl = `/ci/order/attachment/list_for_group`
        return await httpRequest.post<any>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
     //云创订单类别
     async ciImageClassifyList(searchVo: ICiSearchVo) {
        const apiUrl = `/ci/order/image_classification/list`
        return await httpRequest.post<any>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    //云创机构列表
    async ciOrganList(searchVo:ICiSearchVo) {
        const apiUrl = `/ci-platform/organ/page`
        return await httpRequest.post<any>(apiUrl,searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    //用户列表
    async ciUserList(searchVo:ICiSearchVo) {
        const apiUrl = `/ci-customer/customer/user/list`
        return await httpRequest.post<any>(apiUrl,searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    //数据字典
    async ciDict(data = {}) {
        const apiUrl = '/ci/dict/list/all'
        return await httpRequest.post<ICiDict[]>(apiUrl, data, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    //获取静态资源展示地址
    async ciStaticResources() {
        const apiUrl = '/ci-file-server/domain'
        return await httpRequest.get<ICiStaticResourcesType>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }


    
}

export const ciApi = new CI()
